module.exports = __webpack_public_path__ + "img/candidate_website.43538766.svg";